<template>
  <div class="target-and-plan">
    <div class="tuolele-main-box">
      <el-row type="flex" justify="start" class="tuolele-main-search">
        <el-button type="primary" @click="setTarget">目标设置</el-button>
      </el-row>
      <el-form :inline="true" :model="search" class="search-box">
        <el-form-item label="选择店铺">
          <Checkbox
            :list.sync="shopList"
            :select-list="selectSchool"
            @updateCheck="updateCheck"
          />
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            v-if="activeIndex == '0' || activeIndex == '1'"
            v-model="search.time"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="请选择月份"
          />
          <div v-if="activeIndex == '2'" class="date-box">
            <el-date-picker
              v-model="search.begin_time"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择开始月份"
            />
            <span>至</span>
            <el-date-picker
              v-model="search.end_time"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择结束月份"
            />
          </div>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="getData"
          >查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Tablist
      :list="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <div v-if="activeIndex == 0" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售目标
          </div>
          <Pie
            :query-total="itemTotal1"
            :title="'销售总额(￥)'"
            :desc="'目标：'"
            :query-data.sync="salesData"
          />
          <Pie
            :query-total="itemTotal2"
            :title="'新签总额(￥)'"
            :desc="'目标：'"
            :query-data.sync="signingData"
          />
          <Pie
            :query-total="itemTotal3"
            :title="'续费总额(￥)'"
            :desc="'目标：'"
            :query-data.sync="renewalData"
          />
        </div>
      </div>
      <div>
        <div class="color-black data-title">
          招生目标
        </div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <Pie
            :query-total="itemTotal4"
            :title="'新签人数(人)'"
            :desc="'目标：'"
            :query-data.sync="signingPeopleData"
          />
          <Pie
            :query-total="itemTotal5"
            :title="'上门量(人)'"
            :desc="'目标：'"
            :query-data.sync="doorData"
          />
        </div>
      </div>
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black  data-title">
            运营目标
          </div>
          <Pie
            :query-total="itemTotal6"
            :title="'累计课耗人数(人)'"
            :desc="'目标：'"
            :query-data.sync="courseData"
          />
          <Pie
            :query-total="itemTotal7"
            :title="'推荐新签人数(人)'"
            :desc="'目标：'"
            :query-data.sync="recommendData"
          />
        </div>
      </div>
    </div>
    <div v-if="activeIndex == 1" class="dataTable1">
      <div class="tuolele-main-box chart-body flex-wrap">
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'销售总额'"
          :type="'price'"
          :name="'total_price'"
          :count="['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12', 'F4', 'E4']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'续费总额'"
          :type="'price'"
          :name="'renew_price'"
          :count="['F4']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'新签人数'"
          :type="'count'"
          :name="'new_sign_count'"
          :count="['C6', 'C7', 'C8', 'C9', 'C10', 'C11', 'C12']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'新签总额'"
          :type="'price'"
          :name="'new_sign_price'"
          :count="['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'累计课耗人数'"
          :type="'count'"
          :name="'total_count'"
          :count="['I1']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'推荐新签人数'"
          :type="'count'"
          :name="'recommend_new_sign_count'"
          :count="['C13']"
        />
        <CompareData
          :salescompare-data.sync="salesCompareData"
          :title="'上门量目标'"
          :type="'count'"
          :name="'door_count'"
          :count="['B10', 'B11', 'B12', 'B13', 'B14', 'B15', 'B16', 'B17']"
        />
      </div>
    </div>
    <div v-if="activeIndex == 2" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售目标
          </div>
          <BrokenLine
            :title="'销售总额目标完成率'"
            :query-data.sync="historySalesData"
            :type="'price'"
            :name="'total_price'"
            :count="['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12', 'F4', 'E4']"
          />
          <BrokenLine
            :title="'新签总额目标完成率'"
            :query-data.sync="historySalesData"
            :type="'price'"
            :name="'new_sign_price'"
            :count="['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12']"
          />
          <BrokenLine
            :title="'续费总额目标完成率'"
            :query-data.sync="historySalesData"
            :type="'price'"
            :name="'renew_price'"
            :count="['F4']"
          />
        </div>
      </div>
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            招生目标
          </div>
          <BrokenLine
            :title="'新签人数完成率'"
            :query-data.sync="historySalesData"
            :type="'count'"
            :name="'new_sign_count'"
            :count="['C6', 'C7', 'C8', 'C9', 'C10', 'C11', 'C12']"
          />
          <BrokenLine
            :title="'上门量完成率'"
            :query-data.sync="historySalesData"
            :type="'count'"
            :name="'door_count'"
            :count="['B10', 'B11', 'B12', 'B13', 'B14', 'B15', 'B16', 'B17']"
          />
        </div>
      </div>
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            运营目标
          </div>
          <BrokenLine
            :title="'累计消耗完成率'"
            :query-data.sync="historySalesData"
            :type="'count'"
            :name="'total_count'"
            :count="['I1']"
          />
          <BrokenLine
            :title="'推荐新签人数完成率'"
            :query-data.sync="historySalesData"
            :type="'count'"
            :name="'recommend_new_sign_count'"
            :count="['C1']"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tablist from '@/components/toolbar/Tablist.vue'
import Checkbox from '@/components/toolbar/Checkbox.vue'
import Pie from '@/components/chart/Pie.vue'
import BrokenLine from '@/components/chart/BrokenLine.vue'
import CompareData from './CompareData.vue'
export default {
  name: 'TargetAndPlan',
  components: {
    Checkbox,
    Tablist,
    Pie,
    BrokenLine,
    CompareData
  },
  filters: {
    total(total, val2, type) {
      let value = 0
      for (const key in total) {
        if (val2.indexOf(key) > -1) {
          value += Number(total[key])
        }
      }
      if (type == 'price') {
        return value / 100
      } else {
        return value
      }
    },
    rate(target, total, val2) {
      if (target && total) {
        let value = 0
        for (const key in total) {
          if (val2.indexOf(key) > -1) {
            value += Number(total[key])
          }
        }
        let rate = parseInt((value / target) * 100)
        return (rate = rate > 100 ? 100 : rate)
      } else {
        return 100
      }
    }
  },
  data() {
    return {
      search: {
        shop_id: '',
        time: '',
        begin_time: '',
        end_time: ''
      },
      shopList: [],
      selectSchool: [],
      tabList: [
        { id: '0', directory_name: '总览数据' },
        { id: '1', directory_name: '店铺对比数据' },
        { id: '2', directory_name: '历史完成率' }
      ],
      activeIndex: '0',
      itemTotal1: 0,
      itemTotal2: 0,
      itemTotal3: 0,
      itemTotal4: 0,
      itemTotal5: 0,
      itemTotal6: 0,
      itemTotal7: 0,
      count: {
        value1: 0,
        value2: 0,
        value3: 0,
        value4: 0,
        value5: 0,
        value6: 0,
        value7: 0,
        value8: 0,
        value9: 0,
        value10: 0,
        value11: 0,
        value12: 0,
        value13: 0,
        value14: 0
      },
      salesData: [],
      signingData: [],
      renewalData: [],
      signingPeopleData: [],
      doorData: [],
      courseData: [],
      recommendData: [],
      salesCompareData: [],
      historySalesData: [],
      list: []
    }
  },
  created() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    this.search.time = year + '-' + (month - 1)
    this.search.begin_time = year + '-' + (month - 1)
    this.search.end_time = year + '-' + month
  },
  mounted() {
    this.getMyShopList()
  },
  methods: {
    updateCurrentPage(val) {
      this.activeIndex = val
    },
    updateCheck(val) {
      this.selectSchool = val
      this.search.shop_id = val.join(',')
    },
    setTarget() {
      this.$router.push({ path: 'TargetData' })
    },
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = []
        res.data.forEach(item => {
          this.shopList.push({
            text: item.name,
            value: item.id
          })
        })
        this.selectSchool.push(this.shopList[0].value)
        this.search.shop_id = this.shopList[0].value
        this.getData()
      })
    },
    getData() {
      this.getTargetPandect()
      this.getTargetContrast()
      this.getTargetCompletionRate()
    },
    getTargetPandect() {
      this.$http.getTargetPandect(this.search).then(res => {
        if (res.code == 200) {
          const target = res.data.target
          const total = res.data.total
          this.itemTotal1 = Number(target.total_price) || 0
          this.itemTotal2 = Number(target.new_sign_price) || 0
          this.itemTotal3 = Number(target.renew_price) || 0
          this.itemTotal4 = Number(target.new_sign_count) || 0
          this.itemTotal5 = Number(target.door_count) || 0
          this.itemTotal6 = Number(target.total_count) || 0
          this.itemTotal7 = Number(target.recommend_new_sign_count) || 0
          // 销售总额
          this.initCount(
            ['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12', 'F4', 'E4'],
            total,
            'value1'
          )
          this.count.value2 =
            this.itemTotal1 - this.count.value1 / 100 > 0
              ? this.itemTotal1 - this.count.value1 / 100
              : 0
          this.salesData = [
            {
              value: this.count.value1 / 100,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value2,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 新签总额
          this.initCount(
            ['D6', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12'],
            total,
            'value3'
          )
          this.count.value4 =
            this.itemTotal2 - this.count.value3 / 100 > 0
              ? this.itemTotal2 - this.count.value3 / 100
              : 0
          this.signingData = [
            {
              value: this.count.value3 / 100,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value4,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 续费总额
          this.initCount(['F4'], total, 'value5')
          this.count.value6 =
            this.itemTotal3 - this.count.value5 / 100 > 0
              ? this.itemTotal3 - this.count.value5 / 100
              : 0
          this.renewalData = [
            {
              value: this.count.value5 / 100,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value6,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 新签人数
          this.initCount(
            ['C6', 'C7', 'C8', 'C9', 'C10', 'C11', 'C12'],
            total,
            'value7'
          )
          this.count.value8 =
            this.itemTotal4 - this.count.value7 > 0
              ? this.itemTotal4 - this.count.value7
              : 0
          this.signingPeopleData = [
            {
              value: this.count.value7,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value8,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 上门量
          this.initCount(
            ['B10', 'B11', 'B12', 'B13', 'B14', 'B15', 'B16', 'B17'],
            total,
            'value9'
          )
          this.count.value10 =
            this.itemTotal5 - this.count.value9 > 0
              ? this.itemTotal5 - this.count.value9
              : 0
          this.doorData = [
            {
              value: this.count.value9,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value10,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 累计课耗人数
          this.initCount(['I1'], total, 'value11')
          this.count.value12 =
            this.itemTotal6 - this.count.value11 > 0
              ? this.itemTotal6 - this.count.value11
              : 0
          this.courseData = [
            {
              value: this.count.value11,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value12,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
          // 推荐新签人数
          this.initCount(['C13'], total, 'value13')
          this.count.value14 =
            this.itemTotal7 - this.count.value13 > 0
              ? this.itemTotal7 - this.count.value13
              : 0
          this.recommendData = [
            {
              value: this.count.value13,
              key: '0',
              name: '已核算',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.count.value14,
              key: '1',
              name: '差额',
              itemStyle: { color: '#c5d6fb' }
            }
          ]
        }
      })
    },
    getTargetContrast() {
      this.$http.getTargetContrast(this.search).then(res => {
        if (res.code == 200) {
          this.salesCompareData = res.data
        }
      })
    },
    getTargetCompletionRate() {
      this.$http.getTargetCompletionRate(this.search).then(res => {
        if (res.code == 200) {
          this.historySalesData = res.data
        }
      })
    },
    initCount(obj, total, value) {
      this.count[value] = 0
      for (const key in total) {
        if (obj.indexOf(key) > -1) {
          this.count[value] += Number(total[key])
        }
      }
    }
  }
}
</script>

<style lang="scss">
.target-and-plan {
  .search-box {
    margin-top: 20px;
  }
  .el-form-item {
    display: block;
    .el-input {
      width: 150px;
      margin-left: 30px;
      margin-right: 20px;
    }
    .el-form-item__content {
      width: 90%;
    }
  }
  .date-box {
    display: inline;
  }
  .chart-body {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .data-title {
    display: block;
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
  .compare-data {
    margin-bottom: 50px;
    width: 760px;
    .title {
      color: black;
      font-size: 24px;
      margin-bottom: 20px;
    }
  }
}
</style>
